import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AuthService } from '@features/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CollectionModel, ItemModel } from 'collection';
import { Subject } from 'rxjs';
import { ProjectDetailService } from '../services/project-detail.service';

@Component({
  selector: 'project-detail-tooltip',
  templateUrl: './project-detail-tooltip.component.html',
  styleUrls: ['./project-detail-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectDetailTooltipComponent implements OnDestroy {
  @Input() item;
  @Input() hideActionBtns = false;
  @Output() onProjectDeleted = new EventEmitter();
  @Output() onProjectEdited = new EventEmitter();
  @Output() onMenuClose = new EventEmitter();
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  project: ItemModel;
  assignUserCollection: CollectionModel;
  isWorker: boolean;
  private destroyed$ = new Subject();

  emitMenuClose(): void {
    this.onMenuClose.emit();
  }

  identifyUser(index, item) {
    return item.id;
  }

  openMenu() {
    this.menuTrigger.openMenu();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
    this.emitMenuClose();
  }

  open() {
    this.project.setParams('id', this.item.id);
    this.assignUserCollection.setRouteParams('project_id', this.item.id);

    this.project.load().subscribe(() => this._cds.markForCheck());
    if (!this.isWorker) {
      this.assignUserCollection.reload().subscribe(() => this._cds.markForCheck());
    }
  }

  delete() {
    this.closeMenu();
    this.onProjectDeleted.emit(this.project.data);
  }

  edit() {
    this.closeMenu();
    this.onProjectEdited.emit(this.project.data);
  }

  click(e) {
    e.stopPropagation();
  }

  navigateToProject(id) {
    const urlTree = this._router.createUrlTree(['/app/projects/' + id], {
      queryParamsHandling: 'merge',
      preserveFragment: false
    });
    this._router.navigateByUrl(urlTree);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  constructor(
    private _cds: ChangeDetectorRef,
    private _auth: AuthService,
    private _projectDetailService: ProjectDetailService,
    private _translationService: TranslateService,
    private _router: Router
  ) {
    this.project = this._projectDetailService.projectItem;
    this.assignUserCollection = this._projectDetailService.assignUserCollection;
    this.isWorker = this._auth.isWorker();
  }
}
